function formatDate(date) {
  return this.$moment(date).format('YYYY-MM-DD');
}

function formatDateLabel(date) {
  return this.$moment(date).format('Do MMMM, YYYY');
}

function formatDateSmall(date) {
  return this.$moment(date).format('DD/MM/YYYY');
}

function formatDateTime(date) {
  return this.$moment(date).format('YYYY-MM-DD HH:mm');
}

export {
  formatDate,
  formatDateLabel,
  formatDateSmall,
  formatDateTime,
};



// WEBPACK FOOTER //
// ./src/utils/dateFormats.js